import { render, staticRenderFns } from "./ToArchive.vue?vue&type=template&id=c8d0ab6e&scoped=true&"
import script from "./ToArchive.vue?vue&type=script&lang=js&"
export * from "./ToArchive.vue?vue&type=script&lang=js&"
import style0 from "./ToArchive.vue?vue&type=style&index=0&id=c8d0ab6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d0ab6e",
  null
  
)

export default component.exports